
export const EN = require('../../src/static/img/eng.jpeg');
export const JA = require('../../src/static/img/cons/ja.png');
export const IN = require('../../src/static/img/cons/in.png');
export const Logo = require('../../src/static/img/logo4-copy.jpeg');